<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
    <div :class="'tabs is-centered is-boxed has-background-primary' + ($store.getters.isMH ? ' is-small' : ' is-medium')">
      <ul>
        <li :class="currentLevel === 1 ? 'is-active' : ''"><a @click="select(1)">{{ $t('Easy') }}</a></li>
        <li :class="currentLevel === 2 ? 'is-active' : ''"><a @click="select(2)">{{ $t('Normal') }}</a></li>
        <li :class="currentLevel === 3 ? 'is-active' : ''"><a @click="select(3)">{{ $t('Hard') }}</a></li>
      </ul>
    </div>
    <div :class="($store.getters.isMH ? 'is-size-7' : '')">
      <div @click="selectTraining(item.name)" :class="'columns is-mobile' + (i % 2 === 1 ? ($store.getters.isMH ? ' has-background-light' : ' has-background-dark') : '' )" v-for="(item, i) in currentList" :key="i+'card'">
        <div class="column is-3">
          <p :class="($store.getters.isMH ? 'is-size-5' : 'is-size-4') + ' p-l-sm'">
            <span class="icon has-text-lighter">
              <i class="fa fa-clock-o"></i>
            </span>
            {{ item.time }}</p>
        </div>
        <div class="column is-4">
          <img class="image" :src="item.preview">
        </div>
        <div class="column">
          <p v-for="(workout, j) in item.workouts" :key="j+'-'+i">{{ workout.name }}</p>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'TraningList',
  data () {
    return {
      currentLevel: 1,
      currentList: this.$store.getters.getTrainingsByLevel(1)
    }
  },
  mounted() {
    if (typeof this.$store.getters.getTrainingsByLevel !== 'function') {
      this.$router.push({ name: 'Training' })
      this.select(1)
    }
  },
  methods: {
    select (level) {
      this.currentLevel = level
      this.currentList = this.$store.getters.getTrainingsByLevel(this.currentLevel)
    },
    selectTraining (name) {
      this.$router.push({name: 'Training', query: { tn: name }})
      this.$scrollToTop()
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/TrainingList.vue